import React, { useEffect, useState } from "react";
import JobNav from "../../components/Navbar/JobNav";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const JobTeam = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const filterData = [
    {
      id: 0,
      image:
        "https://s3-alpha-sig.figma.com/img/891b/0678/47f6bed168f6a0bcf38bedf53f43c77e?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=gdMqp3eFHWlYs~Am6UDeuqbEz9IUjyiCiMNhd-42vDNgzx0ojV2bL0BksD20i8vVaZKnOGGbeY6dxfhBBmVp8QyQNe1u6LU0yDAqEVJ8xv-EhlMCfhqnxvOLCOLpobtHY~uGEqfZSzJ~x~WoES1jNVXmtxNnmvENM2AznRChhlH1lphePfObu~RFPq8QqB~RyTqTb-LyKKYj1XDVOF~5mwc7srM5xEOrL3TRrUgL9Jwv7s7cqSldcqIl33d2taCD~KQW0vXjwgd8s0SZrGiVwj5FI6Jjd7tnvtnNcnr4gAWdW3tK5YpnvUwloXn21ULM8EZTLnLAVikWggR6xnQlZQ__",
      heading: "Business intelligence and Development ",
      detail: "375 open jobs",
    },
    {
      id: 1,
      image:
        "https://s3-alpha-sig.figma.com/img/cd2a/9d65/1b4acf4407cc010d519843679e3b8465?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=Un6rLLPinL8pdtN6q7-VNjp~1QRN5SccaHZyqy91nM9ySKahpcITKFjJnhvqfUFA22dtRMsU3h45AtkO~-eGYU6sRo5FuC7Ird6gFDQ20x0npc4pjgh~YV2mhKdm-3XqsRlBoBBZsSphO3uqwTPyKARd~aYx7q4fLQjKueDkONVo2KeILRn9GIz8Pw0f6Y-O8L08eiUsyxToKJ6XVub4I2p1sIdwF9EReO03HE7~16xHR7SbwU3GsP5HB7kNo6UMJzNNmooMOMETi6hL~ijjc-PDWCjlb~RMO~AZfEbasMwgdW6~lnufBlFELKEwAFWYHsyOQ-A9jikUCZTWBDsAAA__",
      heading: "IT",
      detail: "375 open jobs",
    },
    {
      id: 2,
      image:
        "https://s3-alpha-sig.figma.com/img/dd07/f8ef/e322b2ccfe8f3704bc5e57e5f9583c8d?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=O4fCVHlKb95uSeOn77ED5y9Skygnf9~fB2XyJ1TujUxURhZpMaitDndJCjHxMUf4EnzVb5949QOqUhrChYKbn-TahecaZ4p~slxu3MBIYn9wMb1FkZR5PcZADSg3wgRnCg~ooGBOKnL6Im7wsXKSUMN-3iwJGTN6eqtq7HYp0z2Y-9Gx7d8YHw20qxI1~x10Gvdqq9gaCGkZesnRUEmO7bV67Czq1WPvGvBIF-vk~L05QQBwEo-cNA65tJsHuA6kgEnzHBZkZDYTHmyRJPBkwwlJrlZdTdqG~o3svrUrE67RYb7~9H7-MIY9~TDAb2tjiRd-K2jowl6T8Re7htxSfw__",
      heading: "Operations",
      detail: "375 open jobs",
    },
    {
      id: 3,
      image:
        "https://s3-alpha-sig.figma.com/img/f308/9ef5/52191a048d46283b031276970ba4fe12?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=mIzy8HtDihMw6Fy952Ai5u-v7Quce2bKffbvIHrv~UFifgbVlwjz5PrXpJg0sxPAZbuyhsscdGA8IULbjYGFrKJff0m9CW6dERk5DkKQabL2o6umL7F8KTNf3iqzrWe3kTI6bz8h5Vz6PV~sIWIDVjgIpsOeJcpJ8ZxLn7HmraJZwr7DROeSkW2neri6EJI3I5LPfmbLA3rWwaS5F0-xw63YZXDTsOfT4ytyp0NtXQlZed8S6k5A0fKuBWPQCPe7i4K962x8Qs6nP2e2IDMIDmrL5jdL8GyZbnQECZU6-DrzdUbrsyfQTrsx3UKXWXl~I34dcoM1Ysb-6lhHOC7zJQ__",
      heading: "Marketing and Sales",
      detail: "375 open jobs",
    },
    {
      id: 4,
      image:
        "https://s3-alpha-sig.figma.com/img/f15d/faec/61fa3f1a6851430979b503f7827a2bfa?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=DF9NKvwotDrAqHGKBwCV1cZ0LIHA59BFcXMH1t99gLQNn37a5XsmZ~UcXE2YUzRpp1r0jkldguSbQx2HEfG6jCr6Eey~vPwP8mooen9XB8i0hEMW9UB3EvHZAL7l1NIHwMulURLfBfxPcmhioT4F-E8uQI845sSkCgNnz-eWSSR1FzSLa9V9UO6uJPaMRhTPzBmo7hg3WgL0d9sEaPmUVXKDba80uhcjrDSR4b5vqlZoynyiO85ksIjur179XV9~BUtQcd580ehz-2eEDtREqYay8t9~k1OszmmhWU1noZc3n7TIQoDRIgotRCKhde~onNwRjuYttSMGvxkq-YgY2Q__",
      heading: "Human Resources",
      detail: "375 open jobs",
    },
    {
      id: 5,
      image:
        "https://s3-alpha-sig.figma.com/img/0994/77c9/3c9f8648f0345966636f354c3419526a?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=JYJ~IQABbezRe7vK-CPUfmAUXLAN-rzfSN5jVHfJCrgQAhLudDmqSE9u1o7IQng3NqbKien3a9SuVKoIwQBMmIppic487yYc4FaTIDiEl0I9FXQ13-QFSoSLKVvsKGiAawdxm-SUlYq3EJkJtjOQ2atKf3WSmf8~9fnCRBCjgT~Hxgf5AK~fO9J8851fePYPoXknL3D7YA4s1iRL5nPsLx77DCIwGKQp2VTHOfrjjGm6KZ6WLL6Xxdb01Tbzno8kF3JS0O8DszLwkxjDUYaSaCAPZLpZVtOu4qTWsywM5Aw~~VmlZchBVJ7QLmoSU-uMJSQZJ2y4iabQxYHvjGQECw__",
      heading: "Legals",
      detail: "375 open jobs",
    },
    {
      id: 6,
      image:
        "https://s3-alpha-sig.figma.com/img/e6b5/49ef/0f43671225eec993f730fbb15fd758ef?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=loteFi4vExDgP8CsMKeiNKKAIDhXAONzmi8wED7gpKbAMyanDt7THBb8mPFaWHgAk31uuZWwjB5vM2723sbsa40ybHtGEhr6aQIvQclrThRmV8Oe10zXE8gjDKv3xjGon0RpxKyCSGnp8ILQ64OGoOcilFAx1dlZI89kFH0mMrHkf7hp-XSxv6wOcxxl6KMvTcdQFCAbhNSsr8a1~Xr2LjaJ6-~mGxzQKtoeR1mP19lqujttX4XwhupVgnYDrNBG8AU7nRDP~Un9QDHtBTPEUjrEzVEzyIii~PDa0ZdSNcftRytcSfc3LiUTeKqgFiod6HfOmjpmEecjnyjDvEgTFQ__",
      heading: "Finance and accounts",
      detail: "375 open jobs",
    },
    {
      id: 7,
      image:
        "https://s3-alpha-sig.figma.com/img/9a0b/b961/275d07ed94f3276c410371d07a202db7?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=s6lHvbHq8KTF-QSYC0222m8jUFwKOpbIWB705EwCxnPIs83iMxzaW1Cczz4skBy7hF-5khG06fYV1k6wF6nv2cC83xO3mW~86dZHqvz8x02RUTubIO0~MUHdfHvHvNwdCIdcnIOvk92eTXTK7PqzrpwPEAaTHWWjPVcopsmXxfQI9lSCwmcIGFlJ2lYBvHjCpeF7tfbdvmP5T0CbxXS9lpxTybmiRRjD5t9D7STe45RcfTMZBcgAMeoUhZjrO2PH9HiVyARPTbus25ctz7PNs1fO285~s0EoeJP4PgmToMzA0cWpGmoVUu-8sdZaY70VwuWpu06jHMKVoWZnhi97uA__",
      heading: "Administration & support",
      detail: "375 open jobs",
    },
    {
      id: 8,
      image:
        "https://s3-alpha-sig.figma.com/img/f750/a411/fce21870f237ba960274e2363e1f2518?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=ihsQoyKC-WRHtIQqY8qjgjRWxJaE0xCco2PFUsZrVR-80c0GSgKr6f0c~EahuhyHhphiiS6ZkTJ8anlzT~Ho~bMdoIv5nqOyAt1DXmw6iszbVjlIUx4U88SleyfjtrLIe8y7FoQxKvxITkooCxRdDAovzne~yFx-uXxh1oFIEJsKTuLVRbyaZV9Y0CkfdAxtyLW4gilMZiihpBlE3phhhTXjylKvqqGcZPLXtVE6wwRHTYzWhc6JVYCX-R349WtYetD7GoHwZsRh6se-4xlwjQ38ylhpJ5aF7ZS37lqYznwc1ej10p2AxUvRXqui~VHQsTHqEAoZCa7sHYeFO6P0TQ__",
      heading: "R&D Training",
      detail: "375 open jobs",
    },
    {
      id: 9,
      image:
        "https://s3-alpha-sig.figma.com/img/1601/fd90/6ff13f5c31a48f84a1a4f7448f89f953?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=tggYqoW2jz4RX95wfL8wZ~7WUQ6DGbB-414GGvfMRxgvZuVmovBzLH5v8BnV0m9gZ73rWa~75B-0kc-hcWh5gJ02IxPij96olubmYLLreziywwxQlFXpb90ZoxJDVhFt6STrTAmKz6D8Bq-ioKDodXrWpoE1QVY54Ob4fTJzY1wc91BGxSoYTDSwEBbrCdaHUc5EWKHsXwzbDnfformv-c4sVX~mBt4PVtsZuomhbWWVJj8LL3MkV1QfmqQp-~DJaraIZqWX7RmQ7gnQkXC-Tw8yjHBny-ExisHsqw58EfG1~4ZCfS8PAt4Qbp6RI-q1BNEP1LoSCZDh0bVJr9da8g__",
      heading: " Warehouse management",
      detail: "375 open jobs",
    },
    {
      id: 10,
      image:
        "https://s3-alpha-sig.figma.com/img/e4d4/aaeb/3993e3c478772cc9f35ed114fd0c17d8?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=rqfmJe9aDEqmn2YRSaezoabFqkQjMkXzgTkhsm5c6GYDBv7aPmFNWiiCRp3DOGs3K9LNYkWrWLAi27sIM2qfwM6Y~wwv6QeKmQMkrHRbzCrNvgeMPumXWmOD~5tt7kYzFF0SJeJs2By92cUCk5s52PlWneSTk6wvTiN2ofAOKM75ayQ4xSDz2r2uygvqCSboP97kz9Qmzu7l2UJorsGzFkqAAJB04OWLWB0ElPnBHvmMtnNSp49uBC1jZlyZnt7SdX1lsvEyCiw-3cM~SVHji~Eps2yPdBLnxKGkVDfPzj5oBqhjqq48P3w5noO~ac3Cfyo4mLSb0KHlGrjWfQa1kQ__",
      heading: "Transport, shipping & logistics",
      detail: "375 open jobs",
    },
    {
      id: 11,
      image:
        "https://s3-alpha-sig.figma.com/img/58cb/c994/880efc6a5fc00f7c51d6597c4ab88a9f?Expires=1739750400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=nCMSEfgTD06oLLE5kIt-6Njl77bMo8nDbx95cs16qFgNZHtDD4oTLE-qXs5C3fQMHaqyvDweHNA7BM88g-qjHzlhWkEjo9BAq9sLcMyEb4ZLsQj0e2BVPwF9OGUJbSn5VragovzLDpmYYzHZti4YrwJ1G960To2jTh4HhNYZfYWqLrltgiB7hi11cPYITsZwLFSrGdzlNxlnSjNLttl2CXKxsVatGuhxqi-NgSPYhhdnbSTt6zio0~Cnz1zJ12qtQpxaoADHnI64fg8Live~~WTtvrcIfFTE6PWpDMaBV57gua-oOH0CwLf0nO4FiPkIf1m5n6JCbJcyE3ZxyUEbGw__",
      heading: " Operations technology",
      detail: "375 open jobs",
    },
  ];

  const isMobile = windowWidth <= 768;
  const cardStyle = {
    width: isMobile ? "calc(100% - 20px)" : "calc(25% - 20px)",
    marginBottom: "20px",
    marginLeft: "10px",
    marginRight: "10px",
    marginTop: "2%",
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className='App'>
      <JobNav />
      <Hero />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          width: "100%",
          marginTop: "2.5%",
        }}
      >
        {filterData.map((item, index) => (
          <div key={index} style={cardStyle}>
            <Card
              image={item?.image}
              title={item?.heading}
              detail={item?.detail}
              price={item?.price}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export const Hero = () => {
  return (
    <>
      <div className='userRegister bg-gray-50'>
        <div className='container py-5'>
          <h1>Find jobs by team</h1>
          <div className='d-flex mt-4 gap-3'>
            <div className='d-flex gap-2 pb-3'>
              <span>Browse open jobs on different teams</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Card = (props) => {
  return (
    <div>
      <div class='card p-1 pb-4' style={{ width: "100%" }}>
        <img
          src={props.image}
          class='card-img-top'
          alt='...'
          style={{ height: 150, width: "100%", alignSelf: "center" }}
        />
        <div class='card-body'>
          <h5 class='card-title h-8'>{props.title}</h5>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            alignItems: "center",
          }}
        >
          <ul class='list-group list-group-flush'>
            <p class='card-text w-40 pl-5'>{props.detail}</p>
          </ul>
          <img
            src={require("../../Assets/image/right.png")}
            style={{ height: 24, width: 24 }}
          />
        </div>
      </div>
    </div>
  );
};

export default JobTeam;
